import * as React from "react";
import {Conductor} from "@models/conductor";
import {Button, Table} from "antd";
import {FormattedMessage, injectIntl} from "react-intl";
import {NavLink} from "react-router-dom";
import {PaginationDefaultParams} from "@components/custom/Paginator";
import FormattedDateTime from "@components/custom/FormattedDateTime";
import {
  DiscountCodePolicyCalculationType,
  DiscountCodePolicyCalculationTypeOptions
} from '../../../models/discountCodePolicy';
import {getFormattedPrice} from "../../../utils";
import __i18n from "../../../intl/__i18n";


type Props = {
  data: Conductor[];
  loading: boolean;
  deleteFn: (item: Conductor) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const ConductorsTable: React.FC<Props> = props => {
  const {data, loading, currentPage} = props;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: "index",
      key: "id",
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: <FormattedMessage id="app.discount_code_unique_identifier" defaultMessage={`Unique Identifier`}/>,
      width: 150,
      align: "right",
      dataIndex: "unique_identifier",
      key: "unique_identifier"
    },
    {
      title: <FormattedMessage id="app.used_count" defaultMessage={`Used Count`}/>,
      align: "center",
      dataIndex: "used_count",
      key: "used_count"
    },
    {
      title: <FormattedMessage id="app.calculation_type" defaultMessage={`Calculation Type`}/>,
      align: "center",
      dataIndex: "calculation_type",
      key: "discount_code_policy",
      render: (item, record) => DiscountCodePolicyCalculationTypeOptions.find(item => item.value === record.discount_code_policy.calculation_type)["label"]
    },
    {
      title: <FormattedMessage id="app.discount_quantity" defaultMessage={`Discount Quantity`}/>,
      align: "center",
      dataIndex: "discount_quantity",
      key: "discount_quantity",
      render: (item, record) => {
        if(record.discount_code_policy.calculation_type === DiscountCodePolicyCalculationType.Percentage){
          return `${record.discount_code_policy.amount} ${__i18n("Percent")}`
        }
        return getFormattedPrice(record.discount_code_policy.amount)
      }
    },
    {
      title: (<FormattedMessage id="app.creation_date" defaultMessage={`Creation Date`}/>),
      width: 150,
      dataIndex: "created_at",
      key: "created_at",
      align:"center",
      render: (created_at, record) => <FormattedDateTime date={created_at}/>
    },
    {
      title: "",
      key: "actions",
      width: 90,
      align:"left",
      render: (text, record) => (
        <NavLink to={`/discount-codes/${record.id}/report`}>
          <Button type="link" icon={'area-chart'}/>
        </NavLink>
      )
    }
  ];
  
  return (
    <Table
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default injectIntl(ConductorsTable);
